import { gql } from '@apollo/client';

export const GET_CALENDAR = gql`
  query GetPractitionerCalendar(
    $practitionerId: ID!
    $filter: FilterPractitionerCalendar!
  ) {
    schedule {
      practitionerCalendar(practitionerId: $practitionerId, filter: $filter) {
        dateRangeAppointmentItems {
          id
          title
          startDate
          endDate
          createdAt
          updatedAt
          note
          eventType
          location {
            id
            name
          }
          isOnline
          patientParticipant {
            patient {
              id
              name {
                firstName
                lastName
              }
              photoUrl
              sendbirdId
            }
            status
          }
          practitionerParticipants {
            practitioner {
              id
              firstName
              lastName
              photoUrl
            }
            status
            acceptOnBehalfOfPatient
          }
          possibleDateRange
          planifiedDuration
          status
          files {
            id
            url
            title
            type
          }
          reservationModeId
          roomId
        }
        preciseDateAppointmentItems {
          id
          title
          startDate
          endDate
          createdAt
          updatedAt
          note
          eventType
          location {
            id
            name
            preferredTimeZone
          }
          isOnline
          patientParticipant {
            patient {
              id
              name {
                firstName
                lastName
              }
              photoUrl
              sendbirdId
            }
            status
          }
          practitionerParticipants {
            practitioner {
              id
              firstName
              lastName
              photoUrl
            }
            status
            acceptOnBehalfOfPatient
          }
          possibleDateRange
          planifiedDuration
          status
          files {
            id
            url
            title
            type
          }
          reservationModeId
          roomId
        }
        absencesItems {
          id
          note
          startDate
          endDate
        }
      }
    }
  }
`;
